/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import axios from 'axios';
import { METERSTOKM, METERSTOMILES } from '../../../constants/CommonConstants';
import { logger } from '@marriott/mi-headless-utils';

export const getSearchResultQuery = (
  searchData: any,
  offerId: string,
  offset: any,
  brandFacets: any,
  isPreview: any,
  customerId: any,
  countriesFacetList: string[],
  statesFacetList: string[],
  citiesFacetList: string[],
  sortBy: string,
  marshCodes?: [],
  clusterCode?: string
): any => {
  let obj;
  if (!isPreview) {
    obj = {
      input: {
        queries: [
          {
            id: 'offers',
            values: String(offerId),
          },
        ],
        facets: {
          terms: [
            {
              type: 'BRANDS',
              dimensions: brandFacets,
            },
          ],
        },
      },
      sort: {
        field: sortBy,
      },
      offset: offset,
      limit: 40,
      larSearch: {
        startDate: searchData?.startDate,
        endDate: searchData?.endDate,
        includeUnavailableProperties: true,
        quantity: Number(searchData?.quantity) ?? 1,
        numberInParty: Number(searchData?.numberInParty) ?? 1,
        childAges: searchData?.childAges?.map((i: string) => (Number.isNaN(Number(i)) ? 0 : Number(i))) ?? [],
        customerId: customerId,
        includeMandatoryFees: true,
      },
      limitPerCategory: 2,
    };

    interface LocationType {
      id: string;
      values: string;
    }

    if (searchData?.latitude && searchData?.longitude) {
      const locDetails: LocationType[] = [
        {
          id: 'latitude',
          values: String(searchData?.latitude),
        },
        {
          id: 'longitude',
          values: String(searchData?.longitude),
        },
      ];

      obj.input.queries.push(locDetails[0]);
      obj.input.queries.push(locDetails[1]);
    } else if (searchData?.stateCode) {
      const stateDetails = {
        id: 'state',
        values: String(searchData?.stateCode),
      };
      obj.input.queries.push(stateDetails);
    } else if (searchData?.countryCode) {
      const countryDetails = {
        id: 'country',
        values: String(searchData?.countryCode),
      };
      obj.input.queries.push(countryDetails);
    }
    // add country facets only when destination is not added
    if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode)) {
      obj.input.facets.terms.push({
        type: 'COUNTRIES',
        dimensions: countriesFacetList,
      });
    }
    // add states facets
    // if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode)) {
    obj.input.facets.terms.push({
      type: 'STATES',
      dimensions: statesFacetList,
    });
    //}
    // add city facets
    // if (!(searchData?.latitude && searchData?.longitude)) {
    obj.input.facets.terms.push({
      type: 'CITIES',
      dimensions: citiesFacetList,
    });
    // }
    if (clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') {
      const pointsOfferReqObj = {
        ...obj,
        larSearch: {
          ...obj.larSearch,
          customerId: customerId,
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: 'MRW',
            },
            {
              type: 'CLUSTER',
              value: 'P17',
            },
            {
              type: 'STANDARD',
              value: '',
            },
          ],
        },
      };
      return pointsOfferReqObj;
    }
  } else {
    obj = {
      search: {
        ids: marshCodes,
        options: {
          startDate: searchData?.startDate,
          endDate: searchData?.endDate,
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: clusterCode,
            },
          ],
          includeUnavailableProperties: true,
          includeTaxesAndFees: false,
          quantity: Number(searchData?.quantity) ?? 1,
          numberInParty: Number(searchData?.numberInParty) ?? 1,
        },
      },
      limit: 40,
      offset: 0,
      filter: [
        'HOTEL_MARKETING_CAPTION',
        'RESORT_FEE_DESCRIPTION',
        'DESTINATION_FEE_DESCRIPTION',
        'SURCHARGE_ORDINANCE_COST_DESCRIPTION',
      ],
      limitPerCategory: 2,
    };
    if (clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') {
      const pointsOfferReqObj = {
        ...obj,
        search: {
          ...obj.search,
          options: {
            ...obj.search.options,
            rateRequestTypes: [
              {
                type: 'CLUSTER',
                value: 'MRW',
              },
              {
                type: 'CLUSTER',
                value: 'P17',
              },
              {
                type: 'STANDARD',
                value: '',
              },
            ],
          },
        },
      };
      return pointsOfferReqObj;
    }
  }
  return obj;
};
export const getDTTSearchResultQuery = (
  searchData: any,
  offerId: string,
  offset: any,
  brandFacets: any,
  customerId: any,
  countriesFacetList: string[],
  statesFacetList: string[],
  citiesFacetList: string[],
  sortBy: string,
  clusterCode?: string
): any => {
  const obj = {
    input: {
      queries: [
        {
          id: 'OFFERS',
          values: String(offerId),
        },
      ],
      facets: {
        terms: [
          {
            type: 'BRANDS',
            dimensions: brandFacets,
          },
        ],
      },
    },
    sort: {
      field: sortBy,
    },
    offset: offset,
    limit: 40,
    search: {
      options: {
        startDate: searchData?.startDate,
        endDate: searchData?.endDate,
        ...((clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17') && {
          rateRequestTypes: [
            {
              type: 'CLUSTER',
              value: 'MRW',
            },
            {
              type: 'CLUSTER',
              value: 'P17',
            },
            {
              type: 'STANDARD',
              value: '',
            },
          ],
        }),
        includeUnavailableProperties: true,
        quantity: Number(searchData?.quantity) ?? 1,
        numberInParty: Number(searchData?.numberInParty) ?? 1,
        childAges: searchData?.childAges?.map((i: string) => (Number.isNaN(Number(i)) ? 0 : Number(i))) ?? [],
        customerId: customerId,
        includeMandatoryFees: true,
        includeTaxesAndFees: false,
      },
    },
    limitPerCategory: 2,
  };
  interface LocationType {
    id: string;
    values: string;
  }
  if (searchData?.latitude && searchData?.longitude) {
    const locDetails: LocationType[] = [
      {
        id: 'LATITUDE',
        values: String(searchData?.latitude),
      },
      {
        id: 'LONGITUDE',
        values: String(searchData?.longitude),
      },
    ];
    obj.input.queries.push(locDetails[0]);
    obj.input.queries.push(locDetails[1]);
  } else if (searchData?.stateCode) {
    const stateDetails = {
      id: 'STATE',
      values: String(searchData?.stateCode),
    };
    obj.input.queries.push(stateDetails);
  } else if (searchData?.countryCode) {
    const countryDetails = {
      id: 'COUNTRY',
      values: String(searchData?.countryCode),
    };
    obj.input.queries.push(countryDetails);
  }
  // add country facets only when destination is not added
  if (!((searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode)) {
    obj.input.facets.terms.push({
      type: 'COUNTRIES',
      dimensions: countriesFacetList,
    });
  }
  // add states facets
  obj.input.facets.terms.push({
    type: 'STATES',
    dimensions: statesFacetList,
  });
  // add city facets
  obj.input.facets.terms.push({
    type: 'CITIES',
    dimensions: citiesFacetList,
  });
  return obj;
};

export const getCommaSeparator = (numb: number, lang: string) => {
  return numb ? Number(Math.floor(numb))?.toLocaleString(lang || '') : null;
};

export const updateSessionObj = async (ariesOffer: any = {}) => {
  const sessionToken = typeof window !== 'undefined' ? window?.sessionData?.sessionToken : '';
  const currentOfferId = window?.location?.pathname ? window?.location?.pathname?.split('/').pop() : '';

  try {
    const url = '/mi/phoenix-gateway/v1/updateSession';
    const headers = {
      Cookie: `sessionID=${sessionToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    };
    const payload = {
      AriesOffer: { ...ariesOffer, AriesOfferId: currentOfferId },
      remove: [],
    };
    await axios
      .post(url, payload, {
        headers: headers,
      })
      .then((res: any) => {
        return res?.status;
      });
  } catch (error) {
    console.log(`OffersPropertiesList update session API Failed:, ${error}`); // eslint-disable-line no-console
  }
};

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};
export function getCalculatedDistance(dist: number | undefined, km: boolean, lang?: string): string | null {
  /** calculated distance for km/ miles */
  if (dist) {
    if (km) {
      // convert meters to km
      return formatNumberByLocale((dist / METERSTOKM).toFixed(1), lang || '');
    } else {
      // convert meters to miles
      return formatNumberByLocale((dist / METERSTOMILES).toFixed(1), lang || '');
    }
  }
  return null;
}
